require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./truncatedtext"), require("./toolbar"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./truncatedtext", "./toolbar"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./truncatedtext"), require("./toolbar")) : factory(root["./utils"], root["./svgicon"], root["./truncatedtext"], root["./toolbar"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__31__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[30],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.iconButtonToggleGroupClassName = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _toolbar = _interopRequireDefault(__webpack_require__(31));

var _IconButtonToggle = _interopRequireDefault(__webpack_require__(102));

var _IconButtonToggleGroup = _interopRequireDefault(__webpack_require__(103));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var iconButtonToggleGroupClassName = _IconButtonToggleGroup["default"].iconButtonToggleGroupClassName.replace(/"/g, '');

exports.iconButtonToggleGroupClassName = iconButtonToggleGroupClassName;

var IconButtonToggleGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(IconButtonToggleGroup, _Component);

  function IconButtonToggleGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = IconButtonToggleGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        items = _this$props.items,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children;
    var classNames = (0, _utils.classnames)(iconButtonToggleGroupClassName);
    var itemElem = children || items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_IconButtonToggle["default"], {
        description: item.description,
        icon: item.icon,
        checked: item.checked,
        onChange: item.onChange,
        disabled: item.disabled,
        onClick: item.onClick,
        key: item.name,
        name: item.name
      });
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames + " " + className,
      style: style
    }, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      value: title,
      className: classNames + "__title"
    }), /*#__PURE__*/_react["default"].createElement(_toolbar["default"], {
      className: classNames + "__container"
    }, itemElem));
  };

  return IconButtonToggleGroup;
}(_react.Component);

exports["default"] = IconButtonToggleGroup;
(0, _defineProperty2["default"])(IconButtonToggleGroup, "propTypes", {
  children: _propTypes["default"].node,

  /** Array of options for IconButtonToggle (Althernative way to render toggles, will be ignored if children nodes are directly passed) */
  items: _propTypes["default"].array,

  /** Custom title label */
  title: _propTypes["default"].string,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom css styles */
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(IconButtonToggleGroup, "defaultProps", {
  items: [],
  title: '',
  style: {},
  className: ''
});

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _svgicon = __webpack_require__(13);

var _baUiCarbon = __webpack_require__(12);

var _IconButtonToggleGroup = __webpack_require__(101);

var _IconButtonToggleGroup2 = _interopRequireDefault(__webpack_require__(103));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var IconButtonToggle = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(IconButtonToggle, _Component);

  function IconButtonToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (button) {
      _this._button = button;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClick", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          onClick = _this$props.onClick,
          name = _this$props.name;
      e.target.blur();
      onChange && onChange(!checked, name);
      onClick && onClick(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          checked = _this$props2.checked,
          onKeyDown = _this$props2.onKeyDown,
          name = _this$props2.name;

      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        onChange && onChange(!checked, name);
      }

      onKeyDown && onKeyDown(e);
    });
    return _this;
  }

  var _proto = IconButtonToggle.prototype;

  _proto.focus = function focus() {
    this._button && this._button.focus();
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        icon = _this$props3.icon,
        description = _this$props3.description,
        style = _this$props3.style,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        checked = _this$props3.checked;
    var tooltipProps = {
      tooltipAlignment: 'center',
      tooltipPosition: 'bottom',
      iconDescription: description
    };
    var classNames = (0, _utils.classnames)(_IconButtonToggleGroup.iconButtonToggleGroupClassName + "__item", {
      checked: checked
    });
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Button, (0, _extends2["default"])({
      "data-tid": _IconButtonToggleGroup.iconButtonToggleGroupClassName + "__item",
      className: classNames + " " + className,
      style: style,
      disabled: disabled,
      kind: "secondary",
      hasIconOnly: true,
      renderIcon: function renderIcon(props) {
        return (0, _svgicon.createIcon)(icon, 'small', null, null, props);
      },
      size: "small",
      ref: this._ref,
      "aria-checked": checked,
      "aria-label": description,
      onClick: this._onClick,
      onKeyDown: this._onKeyDown
    }, tooltipProps));
  };

  return IconButtonToggle;
}(_react.Component);

exports["default"] = IconButtonToggle;
(0, _defineProperty2["default"])(IconButtonToggle, "propTypes", {
  /** Identifier of the button */
  name: _propTypes["default"].string.isRequired,

  /** Callback on the keyDown action on the button */
  onKeyDown: _propTypes["default"].func,

  /** Callback on the click action on the button */
  onClick: _propTypes["default"].func,

  /** Callback on the state change on the button */
  onChange: _propTypes["default"].func,

  /** State of the button */
  checked: _propTypes["default"].bool,

  /** Switch to disable the button */
  disabled: _propTypes["default"].bool,

  /** Custom classnames attached onto the button */
  className: _propTypes["default"].string,

  /** ba-graphics icon (js) in this button */
  icon: _propTypes["default"].object.isRequired,

  /** Text displayed in the button tooltip */
  description: _propTypes["default"].string,

  /** Custom styles attached onto the button */
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(IconButtonToggle, "defaultProps", {
  checked: false,
  disabled: false,
  className: '',
  description: '',
  style: {},
  name: ''
});

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(310);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(309);


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _IconButtonToggleGroup = _interopRequireDefault(__webpack_require__(101));

exports["default"] = _IconButtonToggleGroup["default"];
exports.IconButtonToggleGroup = _IconButtonToggleGroup["default"];

var _IconButtonToggle = _interopRequireDefault(__webpack_require__(102));

exports.IconButtonToggle = _IconButtonToggle["default"];

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__31__;

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-iconButtonToggleGroup__title{font-size:12px;line-height:18px;margin-bottom:6px}.ba-common-iconButtonToggleGroup__container div:first-child button{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.ba-common-iconButtonToggleGroup__container div:last-child button{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.ba-common-iconButtonToggleGroup__item{background:#fff;color:#525252}.ba-common-iconButtonToggleGroup__item:focus{color:inherit;background:inherit;box-shadow:inset 0 0 0 0}.ba-common-iconButtonToggleGroup__item:hover{background:#e5e5e5;color:#161616}.ba-common-iconButtonToggleGroup__item:disabled{background:#fff;color:#c6c6c6;border-color:#fff;box-shadow:none;cursor:default}.ba-common-iconButtonToggleGroup__item.is-checked{background-color:#161616;color:#fff}\n", ""]);

// exports
exports.locals = {
	"iconButtonToggleGroupClassName": "\"ba-common-iconButtonToggleGroup\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[308,0]]]);
});